import {getStartEndWeek} from "../../utils/get-start-end-week";
import {
  SET_PERIOD, NEXT_PERIOD, PREV_PERIOD, 
} from './constants';

const initialWeekPeriod = getStartEndWeek(new Date());

export default function WeeklyPeriodReducer([startWeek, endWeek] = initialWeekPeriod, action){
  switch(action.type){

     case SET_PERIOD:
      return action.period; 

     case NEXT_PERIOD:
      let nextWeek = new Date(startWeek);
          nextWeek.setDate(nextWeek.getDate() + 7);
      return getStartEndWeek(nextWeek)

     case PREV_PERIOD:
      let prevWeek = new Date(startWeek);
          prevWeek.setDate(prevWeek.getDate() - 7);
      return getStartEndWeek(prevWeek);

  }

  return [startWeek, endWeek];
}
